import { Component, isDevMode, OnInit } from "@angular/core";
import { AuthenticationService } from "../../../../auth/service";
import { UtilsService } from "../../../../auth/service/utils.service";
import { TutorialService } from "../../../../auth/service/tutorial.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Router } from "@angular/router";
import { Itutorial } from "../../../../auth/models/tutorial-interface";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";

@Component({
  selector: "app-tutorial-list",
  templateUrl: "./tutorial-list.component.html",
  styleUrls: ["./tutorial-list.component.scss"],
})
export class TutorialListComponent implements OnInit {
  public contentHeader: IContentHeader;
  public searchKey: string = "";
  public tutorialList: Itutorial[] = [];
  public filteredTutorialList: Itutorial[] = [];
  public newTitle: string = "";
  public newDescription: string;
  public current_tutorial: Itutorial = {
    videos: [],
    title: null,
    description: null,
    id: null,
  };
  public video_list: string[] = [];
  public videos_to_remove: string[] = [];
  public showModalError: boolean = false;

  constructor(
    public _authenticationService: AuthenticationService,
    public _utilService: UtilsService,
    private _tutorialService: TutorialService,
    private _modalService: NgbModal,
    private _routerService: Router,
  ) {
    this.contentHeader = {
      headerTitle: "MENU.TUTORIAL",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: "MENU.MANAGE",
            isLink: true,
            link: "/dashboard/platform-management",
          },
          {
            name: "MENU.TUTORIAL",
            isLink: false,
          },
        ],
      },
    };
  }

  async ngOnInit() {
    if (!this._authenticationService.hasCapability("view_tutorial_list")) {
      await this._routerService.navigateByUrl("/dashboard/main");
    }
    await this.loadTutorial();
    await this.searchTutorial();
  }

  async loadTutorial() {
    this.tutorialList = await this._tutorialService.getList();
  }

  async searchTutorial() {
    const key: string = this.searchKey.trim().toLowerCase();
    let filteredTutorialList: Itutorial[] = this.tutorialList;
    if (key.length > 0) {
      filteredTutorialList = filteredTutorialList.filter((item: Itutorial) => {
        return item.title.toLowerCase().includes(key);
      });
    }
    this.filteredTutorialList = filteredTutorialList;
  }

  async addTutorial() {
    const videosList: string[] = this.video_list.filter((v: string) => v !== "");
    if (!!this.newTitle) {
      this.newTitle = this.newTitle.trim();
    }

    if (!this.newTitle || this.newTitle.length < 1) {
      this.showModalError = true;
      return false;
    }

    if (videosList.length < 3) {
      await this._utilService.showSWALError({ text: "VIDEOS_REQUIRED" });
      return false;
    }

    this._utilService.showLoading();
    await this._tutorialService
      .createTutorial({
        title: this.newTitle,
        description: this.newDescription || null,
      })
      .then(async (response: { id: number }) => {
        const uploadedVideos = await this.uploadVideos(response.id);
        this._utilService.hideLoading();
        if (uploadedVideos) {
          await this.modalClose().then(async () => {
            await this.loadTutorial();
            await this.searchTutorial();
            await this._utilService.showSWALSuccess({ text: "SUCCESS_UPLOAD_TUTORIAL" });
          });
        } else {
          await this._utilService.showSWALError({ text: "ERROR_TUTORIAL_UPLOAD" });
        }
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_TUTORIAL_UPLOAD" });
      });
  }

  async editTutorial() {
    if (!!this.current_tutorial.title) {
      this.current_tutorial.title = this.current_tutorial.title.trim();
    }
    if (!this.current_tutorial.title || this.current_tutorial.title.length < 1) {
      this.showModalError = true;
      return false;
    }

    if (this.videos_to_remove.length > 0) {
      await this._utilService.showSWALError({ text: "VIDEOS_REQUIRED" });
      return false;
    }
    this._utilService.showLoading();
    await this._tutorialService
      .updateTutorial(this.current_tutorial.id, {
        title: this.current_tutorial.title,
        description: this.current_tutorial.description || null,
      })
      .then(async () => {
        await this.uploadVideos(this.current_tutorial.id).then(async (success: boolean) => {
          if (success) {
            if (this.videos_to_remove.length > 0) {
              let removedVideos: number = 0;

              for (let format of this.videos_to_remove) {
                await this._tutorialService.deleteVideo(this.current_tutorial.id, format);
                removedVideos++;
              }
              if (removedVideos === this.video_list.length) {
                await this.modalClose();
                await this.loadTutorial();
                await this.searchTutorial();
                this.current_tutorial.videos = [];
              } else {
                success = false;
              }
            } else {
              await this.modalClose();
              await this.loadTutorial();
              await this.searchTutorial();
            }
          }
          this._utilService.hideLoading();
          if (success) {
            await this._utilService.showSWALSuccess({ text: "SUCCESS_EDIT_TUTORIAL" });
          } else {
            await this._utilService.showSWALError({ text: "ERROR_TUTORIAL_EDIT" });
          }
        });
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_TUTORIAL_EDIT" });
      });
  }

  async deleteTutorial(currentTutorial: Itutorial) {
    let deleteText: string = await this._utilService.translate("ALERT.CONFIRM_DELETE_TEXT");
    deleteText += await this._utilService.translate("ALERT.CONFIRM_DELETE_THIS_OBJECT");
    deleteText += currentTutorial.title;
    await this._utilService.showSWALDeleteConfirmation({ text: deleteText }).then(async (result) => {
      if (result.value) {
        this._utilService.showLoading();
        await this._tutorialService
          .deleteTutorial(currentTutorial.id)
          .then(async () => {
            await this.loadTutorial();
            await this.searchTutorial();
            this._tutorialService.video_to_play = "";
            this._utilService.hideLoading();
            await this._utilService.showPopupItemDeleted();
          })
          .catch(() => {
            this._utilService.hideLoading();
            this._utilService.showSWALError({ text: "ERROR_TUTORIAL_DELETE" });
          });
      } else if (result.isDismissed) {
        await this._utilService.showSWALError({
          title: "ABORTED_TITLE",
          text: "ABORTED_TEXT",
        });
      }
    });
  }

  async addVideoToList(file) {
    file = file[0];
    if (file.type.includes("mp4")) {
      this.video_list[0] = file;
    } else if (file.type.includes("webm")) {
      this.video_list[2] = file;
    } else {
      this.video_list[1] = file;
    }
  }

  async editVideoToList(file) {
    file = file[0];
    const filename: string = file.name;

    this.video_list.push(file);

    if (filename.includes("mp4")) {
      this.current_tutorial.videos[0] = `tutorial/${this.current_tutorial.id}.mp4`;
    } else if (filename.includes("webm")) {
      this.current_tutorial.videos[2] = `tutorial/${this.current_tutorial.id}.webm`;
    } else {
      this.current_tutorial.videos[1] = `tutorial/${this.current_tutorial.id}.${file.type.split("/")[1]}`;
    }

    if (this.videos_to_remove.length > 0) {
      this.videos_to_remove.pop();
    }

    // this.videos_to_remove = this.videos_to_remove.filter((format: string) => format !== filename)
  }

  // funzione per importare i file
  async uploadVideos(id) {
    if (this.video_list.length == 0) {
      return true;
    }
    try {
      await this._tutorialService.uploadVideos(this.video_list, id);
      return true;
    } catch (e) {
      console.error(e);
      return false;
    }
  }

  async openModal(modalBasic, currentTutorial: Itutorial) {
    this._tutorialService.video_to_play = "";
    this.newTitle = "";
    this.newDescription = "";
    this.video_list = [];
    this.videos_to_remove = [];
    this._modalService.open(modalBasic, {
      size: "lg",
      centered: true,
    });
    this.current_tutorial = JSON.parse(JSON.stringify(currentTutorial));
    this.showModalError = false;
  }

  async modalClose() {
    // this._tutorialService.video_to_play = ''
    this._modalService.dismissAll();
    this.newTitle = "";
    this.newDescription = "";
    this.video_list = [];
    this.videos_to_remove = [];
  }

  async softDeleteVideo(index: number) {
    if (this.current_tutorial) {
      this.videos_to_remove.push(["mp4", "ogg", "webm"][index]);
      this.current_tutorial.videos[index] = "";
    }
    delete this.video_list[index];
  }

  showVideo() {
    if (!this.current_tutorial) {
      return null;
    }

    this._tutorialService.video_to_play = this.current_tutorial.title;
    this._tutorialService.force_open_modal = true;
  }

  isDevMode() {
    return isDevMode();
  }
}
